/** @format */

import React, { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Tabs } from "antd";
import { BreadCrumb } from "../../../components";

import { useHistory } from "react-router-dom";

import { ContentVerification } from "./ContentVerification";
import { ContentPengajuan } from "./ContentPengajuan";
import { ContentPenyaluran } from "./ConstentPenyaluran";

const PengajuanPencairanBos = () => {
  const itemBreadcrumb = [
    { path: "/", breadcrumbName: "Home" },
    { path: "/", breadcrumbName: "Pencairan Dokumen BOS" },
    { path: "/", breadcrumbName: "Pengajuan Pencairan" },
  ];
  const route = useHistory();
  const itemsTab = [
    {
      label: "Verifikasi",
      key: `verifikasi`,
    },
    {
      label: "Pengajuan",
      key: `pengajuan`,
    },
    {
      label: "Penyaluran",
      key: `penyaluran`,
    },
  ];
  const { auth, provinsi, kabkota, store } = useSelector(
    (state: any) => ({
      auth: state.auth?.data || null,
      provinsi: state.store?.provinsi,
      kabkota: state.store?.kabkota,
      store: state.store,
    }),
    shallowEqual,
  );
  const dataState: any = route.location.state || {};
  const [activeTabKey, setActiveTabKey] = useState<string>(
    dataState?.activeTabKey || "verifikasi",
  );
  dataState.activeTabKey = activeTabKey;
  const handleContent = (values: any) => {
    switch (values) {
      case "verifikasi":
        return (
          <ContentVerification
            auth={auth}
            kabkota={kabkota}
            provinsi={provinsi}
            store={store}
            dataState={dataState}
          />
        );
      case "pengajuan":
        return (
          <ContentPengajuan route={route} auth={auth} dataState={dataState} />
        );
      case "penyaluran":
        return (
          <ContentPenyaluran route={route} auth={auth} dataState={dataState} />
        );
      default:
        return (
          <ContentVerification
            auth={auth}
            kabkota={kabkota}
            provinsi={provinsi}
            store={store}
            dataState={dataState}
          />
        );
    }
  };

  return (
    <>
      <BreadCrumb
        routes={itemBreadcrumb}
        title="Pengajuan Pencairan"
        footer={
          <Tabs
            defaultActiveKey={activeTabKey}
            size="small"
            onChange={(key) => {
              setActiveTabKey(key);
            }}
            items={itemsTab}
          />
        }
      />
      <div className="m-5 p-5 bg-white shadow-md rounded">
        {handleContent(activeTabKey)}
      </div>
    </>
  );
};

export default PengajuanPencairanBos;
